/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Events_Not_In_Team_Project_IntroInputs */

const en_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following Event Groups are not part of the team project and were not synced with the server. These Event Groups only exist on your system.`)
};

const fr_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les groupes d’événements suivants ne font pas partie du projet d’équipe et n’ont pas été synchronisés avec le serveur. Ces groupes d’événements n’existent que sur votre système.`)
};

const de_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die folgenden Ereignisgruppen gehören nicht zum Teamprojekt und wurden nicht mit dem Server synchronisiert. Diese Ereignisgruppen existieren nur auf Ihrem System.`)
};

const it_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I seguenti gruppi di eventi non fanno parte del progetto del team e non sono stati sincronizzati con il server. Questi gruppi di eventi esistono solo sul tuo sistema.`)
};

const ru_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующие группы событий не являются частью командного проекта и не были синхронизированы с сервером. Эти группы событий существуют только в вашей системе.`)
};

const es_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los siguientes grupos de eventos no forman parte del proyecto de equipo y no se sincronizaron con el servidor. Estos grupos de eventos solo existen en su sistema.`)
};

const zh_cn2_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下事件组不属于团队项目，也未与服务器同步。这些事件组仅存在于您的系统中。`)
};

const ja_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下のイベントグループはチームプロジェクトの一部ではなく、サーバーと同期されていません。これらのイベントグループはシステム上にのみ存在します。`)
};

const hi_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निम्नलिखित इवेंट समूह टीम प्रोजेक्ट का हिस्सा नहीं हैं और सर्वर के साथ सिंक्रोनाइज़ नहीं किए गए हैं। ये इवेंट समूह केवल आपके सिस्टम पर मौजूद हैं।`)
};

const pt_pt2_team_sync_events_not_in_team_project_intro = /** @type {(inputs: Team_Sync_Events_Not_In_Team_Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os seguintes Grupos de Eventos não fazem parte do projeto da equipe e não foram sincronizados com o servidor. Esses Grupos de Eventos existem apenas no seu sistema.`)
};

/**
* | output |
* | --- |
* | "The following Event Groups are not part of the team project and were not synced with the server. These Event Groups only exist on your system." |
*
* @param {Team_Sync_Events_Not_In_Team_Project_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_events_not_in_team_project_intro = /** @type {((inputs?: Team_Sync_Events_Not_In_Team_Project_IntroInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Events_Not_In_Team_Project_IntroInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "de") return de_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "it") return it_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "ru") return ru_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "es") return es_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "ja") return ja_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "hi") return hi_team_sync_events_not_in_team_project_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_events_not_in_team_project_intro(inputs)
	return en_team_sync_events_not_in_team_project_intro(inputs)
});